import { atom } from 'recoil';

export const isWorkersFilterModalOpenAtom = atom<boolean>({
  key: 'isWorkersFilterModalOpenState',
  default: false,
});
